import React from 'react';
import DepartmentPaymentRequests from '../../components/DepartmentPaymentRequests';

const ProjectsPaymentRequests = () => {
  return <DepartmentPaymentRequests department="PROJECTS" departmentLabel="Projects Dept" />;
};

export default ProjectsPaymentRequests;
